import { useFetcher, useLocation, useNavigate } from '@remix-run/react'
import { useEffect, useState } from 'react'
import { validateEmail } from '../helpers/utilsValidation'
import { Button, Divider, Link, LoadingDots, TextInput, Toast } from '../primitives'

import { STEPS_URLS } from './Breadcrumb'
import { Input, Key, TrendingFlat } from '~/icons'

export default function LoginForm() {
  const navigate = useNavigate()
  const fetcher = useFetcher()
  const [secondStage, setSecondStage] = useState(true)

  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const authStatus = queryParams.get('authStatus')

  const handleQuickAccessClick = (email: string) =>
    navigate(`/quickaccess?email=${email}&ReturnUrl=${queryParams.get('ReturnUrl') || STEPS_URLS.CART}`)
  const handleForgetPassword = (email: string) =>
    navigate(`/forgetpassword?email=${email}&ReturnUrl=${queryParams.get('ReturnUrl') || STEPS_URLS.CART}`)

  const [toastOpen, setToastOpen] = useState(false)

  const [formValues, setFormValues] = useState({
    email: '',
    password: '',
  })

  const [errors, setErrros] = useState({
    email: '',
    password: '',
  })

  const handleChangeEmail = () => {
    setFormValues({ email: '', password: '' })
    setSecondStage(false)
    setTimeout(() => {
      setSecondStage(true)
    }, 0)
  }

  useEffect(() => {
    if (authStatus === 'Success') {
      setToastOpen(true)
    }
  }, [authStatus])

  useEffect(() => {
    const actionType = (fetcher.data as { actionType: string })?.actionType

    if (secondStage === false && formValues.email === '') {
      return setSecondStage(true)
    }

    if (actionType === 'continue' && fetcher.state === 'idle' && fetcher.data) {
      let newCostumer = fetcher.data as { apiresult: { isNewCustomer: boolean } }
      if (newCostumer.apiresult.isNewCustomer == true) {
        return navigate(`/register`)
      }
      if (formValues.email != '') {
        fetcher.data = null
        return setSecondStage(false)
      }
    }

    if (actionType === 'login' && fetcher.state === 'idle' && fetcher.data) {
      const erroStatus = Number((fetcher.data as { error?: { status?: number } })?.error?.status)
      if (erroStatus && (erroStatus < 200 || erroStatus >= 300)) {
        return setErrros((prevErrors) => ({
          ...prevErrors,
          password: 'Email ou senha inválidos',
        }))
      }
    }

    setErrros((prevErrors) => ({
      ...prevErrors,
      email: '',
      password: '',
    }))
  }, [formValues.email, secondStage, navigate, fetcher])

  return (
    <fetcher.Form
      action={`/access?ReturnUrl=${location.search}`}
      className="flex gap-6 flex-col"
      method="post"
    >
      <div className="flex flex-col gap-1">
        <TextInput
          description="Informe e-mail de cadastro ou cadastre-se."
          errorMessage={validateEmail(formValues.email) || ''}
          id="email"
          isDisabled={!secondStage}
          label="Email"
          name="email"
          pattern={validateEmail(formValues.email) || undefined}
          type="email"
          value={formValues.email}
          onChange={(e) => {
            setFormValues({ ...formValues, email: e.target.value })
            setErrros({ ...errors, email: '' })
          }}
        />
      </div>
      {secondStage ? (
        <>
          <Button
            className="flex items-center justify-center gap-4"
            color="primary"
            isDisabled={validateEmail(formValues.email) !== null}
            name="actionType"
            type="submit"
            value="continue"
          >
            {fetcher.state === 'submitting' ? (
              <LoadingDots color="orange" />
            ) : (
              <>
                <TrendingFlat className="fill-white" /> Continuar
              </>
            )}
          </Button>
          {toastOpen ? (
            <Toast
              altText="restore"
              content="Senha alterada com sucesso "
              isOpen={toastOpen}
              status="success"
              onOpenChange={setToastOpen}
            />
          ) : null}
        </>
      ) : (
        <>
          <TextInput
            errorMessage={errors.password || 'Insira uma senha válida'}
            id="password"
            isInvalid={!!errors.password}
            label="Senha:"
            name="password"
            type="password"
            required
            onChange={(e) => {
              setFormValues({ ...formValues, password: e.target.value })
              setErrros({ ...errors, password: '' })
            }}
          />

          <div className="flex justify-between">
            <Link
              variant="primary"
              onPress={() => {
                return handleForgetPassword(formValues.email)
              }}
            >
              Esqueci minha senha
            </Link>
            <Link variant="primary" onPress={handleChangeEmail}>
              Alterar e-mail
            </Link>
          </div>
          <Button
            className="flex items-center justify-center gap-4 relative"
            color="primary"
            name="actionType"
            type="submit"
            value="login"
          >
            <Input className="fill-white" />
            Entrar
            {fetcher.state === 'submitting' ? (
              <div className="flex items-center justify-center absolute inset-1/2 w-full h-full -translate-y-1/2 -translate-x-1/2">
                <LoadingDots color="orange" />
              </div>
            ) : null}
          </Button>
          <div className="flex items-center gap-2 self-strech">
            <Divider />
            <span className="text-xs font-medium tracking-[0.0094rem]">ou</span>
            <Divider />
          </div>
          <Button
            className="group flex items-center justify-center gap-4"
            color="primary"
            isOutlined={true}
            name="actionType"
            type="button"
            onPress={() => handleQuickAccessClick(formValues.email)}
          >
            <Key className="group-hover:fill-primary-medium fill-primary-orange" />
            Acesso Rápido
          </Button>
        </>
      )}
    </fetcher.Form>
  )
}
